import styled from '@emotion/styled';

export const StyledActionCell = styled('div')`
  display: flex;
  height: 100%;
  align-items: center;
  margin-right: 10px;
  justify-content: flex-end;
  min-width: 80px;
`;
